import {Row,Col,Button} from "reactstrap";
import Sidebar from '../../Sidebar';
import { useParams, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import { getCubeTestReportDetails,updateCubeTestReport,deleteCubeTestReport,cancelCubeTestReport,printCubeTestReport, getPendingCubeTestReports } from '../../services/CubeTestReportServices';
import TableRowsCubeTestReportEdit from "./TableRowsCubeTestReportEdit";
import FloatingControls from '../../components/FloatingControls';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import LoadingOverlay from '../../components/LoadingOverlay';
import React from 'react';
import { useState, useEffect ,useMemo} from "react";
import Swal from "sweetalert2";
import { getUserAllowedPlants } from '../../services/PlantServices';
import { displayError } from '../../helpers';
import { getDisplayDate } from '../../utils/DateUtils';
import ReactTablePopUpSubmitWrapper from "../../components/ReactTablePopUpSubmitWrapper";
import CubeTestReportSelectionBanner from './CubeTestReportSelectionBanner';
import CubeTestReportAgePanel from './CubeTestReportAgePanel';
import { openPdfResponse } from '../../utils/openPdfInApp';
import {
  buildPendingAgeRow,
  buildPendingListTitle,
  buildReportNumberDisplay,
  buildCsrRowsFromAgeSetup,
  buildCubeIdFromSelection,
  syncCubeIdsForAgeRows,
  resolveNextAgeDays,
  applyAgeRowFieldChange,
  castingDateInputFromApi,
  decoratePendingRecords,
  getInitialCubeTestReportFormState,
  getPendingColumns,
  getPendingQueryRange,
  mapAllowedPlants,
  reportDateFromCastingAndAge,
  resolveCuredPlaceFromAgeRows,
  CUBE_ID_COLUMN_MIN_WIDTH,
} from './cubeTestReportDefaults';

function CubeTestReportEdit() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [cookies] = useCookies(['myToken']);
  const [inputs, setInputs] = useState(getInitialCubeTestReportFormState());
  const [inProgress, setInProgress] = useState(false);
  const [dcGroup,setDcGroup]=useState([]);
  const [SelectedDcGroup,setSelectedDcGroup]=useState({});
  const [plants, setPlants] = React.useState([]);
  const [csrRows, setCsrRows] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [pendingModalTitle, setPendingModalTitle] = useState('');
  const [pendingAgeDays, setPendingAgeDays] = useState(null);
       
  const applyPendingSelectionToEdit = (selected, ageDays) => {
    setSelectedDcGroup({
      id: selected.id,
      project_name: selected.project_name,
      customer_name: selected.customer_name,
      marketing_name: selected.marketing_name,
      total_dc_qty: selected.total_dc_qty,
      delivery_challan_date: selected.delivery_challan_date,
      product_name: selected.product_name,
      grade_number: selected.grade_number,
      dc_ids_list: selected.dc_ids_list,
      customer_id: selected.customer_id,
      consignee_id: selected.consignee_id,
      product_id: selected.product_id,
    });
    const castingDt = castingDateInputFromApi(selected.delivery_challan_date);
    const cubeId = buildCubeIdFromSelection(selected, ageDays, castingDt);
    setInputs((values) => ({
      ...values,
      casting_dt: castingDt,
      csr_date: reportDateFromCastingAndAge(castingDt, ageDays) || values.csr_date,
      pending_age_days: ageDays,
      cured_place: values.cured_place || 'plant',
    }));
    setRowsData(syncCubeIdsForAgeRows(
      [buildPendingAgeRow(ageDays, cubeId, inputs.cured_place || 'plant')],
      selected,
      castingDt,
    ));
    setShowPendingModal(false);
  };

  const openPendingList = (ageDays) => {
    if (!inputs.plant_id) {
      Swal.fire('Plant is not loaded yet.', '', 'info');
      return;
    }
    const queryRange = getPendingQueryRange(ageDays);
    setIsLoading(true);
    setPendingAgeDays(ageDays);
    getPendingCubeTestReports(cookies, inputs.plant_id, ageDays, {
      fromDate: queryRange.fromDate.format('DD-MM-YYYY'),
      uptoDate: queryRange.uptoDate.format('DD-MM-YYYY'),
    })
      .then((response) => {
        const tableData = decoratePendingRecords(response.pending_list);
        setDcGroup(tableData);
        setPendingModalTitle(buildPendingListTitle(ageDays, queryRange.fromDate, queryRange.uptoDate));
        setShowPendingModal(true);
        setIsLoading(false);
        if (!tableData.length) {
          Swal.fire(
            `No pending ${ageDays}-day records found for this plant in the last 90 days.`,
            '',
            'info',
          );
        }
      })
      .catch((error) => {
        setIsLoading(false);
        displayError(error.response?.data, ' Failed');
      });
  };

  const handlePendingRowSelect = (value) => {
    const selected = dcGroup.find((obj) => obj.id == value);
    if (!selected) {
      return;
    }
    if (selected.pending_type === 'update' && selected.csr_id && String(selected.csr_id) !== String(id)) {
      setShowPendingModal(false);
      navigate(`/CubeTestReportEdit/${selected.csr_id}/?pendingAge=${pendingAgeDays || 28}`);
      return;
    }
    applyPendingSelectionToEdit(selected, pendingAgeDays);
  };

  React.useEffect(() => {
    getUserAllowedPlants(cookies)
      .then((plantList) => {
        setPlants(mapAllowedPlants(plantList));
      });
  }, [cookies]);

  React.useEffect(() => {
    if (id) {
      setInProgress(true);
      getCubeTestReportDetails(cookies, id)
        .then(response => {
          setInProgress(false);
          setInputs({
            id: response.id,
            plant_id: response.plant.id,
            user_remarks: response.user_remarks,
            cured_place: response.cured_place,
            cube_test_report_no: response.cube_test_report_no,
            csr_no: buildReportNumberDisplay(response.prefix, response.cube_test_report_no),
            csr_date: getDisplayDate(response.cube_test_report_date),
            prefix: response.prefix,
            supplied_qty: response.supplied_qty,
            casting_dt: getDisplayDate(response.casting_dt),
            technician_name: response.technician_name,
            cement_type: response.cement_type,
            cement_content: response.cement_content,
            no_of_moulds: response.no_of_moulds,
          });
          // Create a map to count occurrences of each `age`
          const ageCountMap = response.detail_list.reduce((map, item) => {
              map[item.age] = (map[item.age] || 0) + 1;
              return map;
          }, {});
          console.log(JSON.stringify(ageCountMap)+"ageCountMap");
          // Add the `no_of_rows` property to each object
          const updatedDetailList = response.detail_list.map((item,index) => {
            var per_csr = item.age/(4.7+(0.832*(item.age)))*100;
            var grade =response.grade.grade_number;
            // console.log(grade+"grade");
            var cube_strength = (parseInt(grade)*per_csr/100).toFixed(2);
            // console.log(JSON.stringify(item)+"item")
            // console.log(cube_strength+"cube_strength")
            if(parseFloat(item.act_strength)>=parseFloat(cube_strength)){
              item['act_strength_result']= 'PASS'
            }
            else{
              item['act_strength_result']= 'FAIL'
            }
            if(parseFloat(item.cus_strength)>=parseFloat(cube_strength)){
              item['cus_strength_result']= 'PASS'
            }
            else{
              item['cus_strength_result']= 'FAIL'
            }
            if(parseFloat(item.act_average)>=parseFloat(cube_strength)){
              item['act_result']= 'PASS'
            }
            else{
              item['act_result']= 'FAIL'
            }
            if(parseFloat(item.cus_average)>=parseFloat(cube_strength)){
              item['cus_result']= 'PASS'
            }
            else{
              item['cus_result']= 'FAIL'
            }
            item['ref_cube_strength']=cube_strength;
            return {
            ...item,
            no_of_rows: ageCountMap[item.age],
            sl_no :index + 1,
          }});
          setCsrRows(updatedDetailList)
          setSelectedDcGroup({id:1,project_name:response.consignee.project_name,
            customer_name:response.consignee.customer.name,
            marketing_name: response.consignee.customer.salesrep.alias
              || response.consignee.customer.salesrep.name,
            total_dc_qty:response.supplied_qty,
            delivery_challan_date:response.casting_dt,
            product_name:response.grade.name,
            grade_number:response.grade.grade_number,
            dc_ids_list:response.dc_ids_list,
            customer_id:response.consignee.customer.id,
            consignee_id:response.consignee.id,
            product_id:response.grade.id})
        }).catch(error => {
          setInProgress(false);
          displayError(error.response?.data, "Loading Failed");
        });
    }
  }, [cookies, id]);

  React.useEffect(() => {
    const pendingAge = parseInt(searchParams.get('pendingAge') || '', 10);
    if ((pendingAge === 7 || pendingAge === 28) && inputs.plant_id && SelectedDcGroup?.customer_name) {
      const cubeId = buildCubeIdFromSelection(SelectedDcGroup, pendingAge, inputs.casting_dt);
      setRowsData(syncCubeIdsForAgeRows(
        [buildPendingAgeRow(pendingAge, cubeId, inputs.cured_place || 'plant')],
        SelectedDcGroup,
        inputs.casting_dt,
      ));
      setInputs((values) => ({ ...values, pending_age_days: pendingAge }));
    }
  }, [searchParams, inputs.plant_id, SelectedDcGroup?.customer_name, SelectedDcGroup?.product_name, inputs.cured_place]);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    // console.log(name+"name")
    // console.log(value+"value")   
    setInputs(values => ({ ...values, [name]: value })) 
  }

  const navigate = useNavigate();

  const view = () => {
      navigate('/CubeTestReportTable')
  }  
      
  const Back = () => {
    navigate('/Home')
  }

  const Cancel = () => {
    navigate(`/CubeTestReportEdit/${id}/`, { replace: true });
  }

  const handlePrint = (event) => {
    event.preventDefault();
    if (!id) {
      return;
    }
    setInProgress(true);
    printCubeTestReport(cookies, id)
      .then((response) => {
        openPdfResponse(response, {
          title: 'Compressive Strength Report',
          downloadFileName: 'compressive_strength_report.pdf',
        });
      })
      .catch((error) => {
        displayError(error?.response?.data ?? error, 'Print failed');
      })
      .finally(() => setInProgress(false));
  };
      
  const handleChangeCsr = (index, evnt)=>{
        const { name, value } = evnt.target;
        const CsrRowsInput = [...csrRows];
        CsrRowsInput[index][name] = value;
        if (name==='act_load' || name === 'cus_load'){
          const strength=(value/22.5).toFixed(2);
          const age =parseInt(CsrRowsInput[index]['age']);
          const no_of_rows =CsrRowsInput[index]['no_of_rows'];
          var total = parseFloat(strength);
          var per_csr = age/(4.7+(0.832*age))*100;
          var grade =SelectedDcGroup.grade_number;
          // console.log(grade+"grade");
          var cube_strength = (parseInt(grade)*per_csr/100).toFixed(2);
          CsrRowsInput[index]['ref_cube_strength']=cube_strength;
          CsrRowsInput.map((row,row_index)=>{
            // console.log(JSON.stringify(row)+"row"+row_index+"row_index");
            if((parseInt(row['age']) === age) && (row_index != index)){
              if (name==='act_load'){
              total+= parseFloat(row['act_strength'])
              }
              else{
                total+= parseFloat(row['cus_strength'])
              }
            }
          })
          var average = (total/no_of_rows).toFixed(2);
          CsrRowsInput.map((row_1,row_index_1)=>{
            // console.log(JSON.stringify(row)+"row"+row_index+"row_index");
            if(parseInt(row_1['age']) === age){
              if (name==='act_load'){
                CsrRowsInput[index]['act_strength'] = strength;
                CsrRowsInput[row_index_1]['act_average'] = average;
                CsrRowsInput[row_index_1]['act_difference']= (parseFloat(average)-CsrRowsInput[row_index_1]['act_strength']).toFixed(2);
                CsrRowsInput[index]['cus_load'] = value;
                CsrRowsInput[index]['cus_strength'] = strength;
                CsrRowsInput[row_index_1]['cus_average'] = average;
                CsrRowsInput[row_index_1]['cus_difference']= (parseFloat(average)-CsrRowsInput[row_index_1]['act_strength']).toFixed(2);
                if(parseFloat(strength)>=parseFloat(cube_strength)){
                  CsrRowsInput[index]['act_strength_result']= 'PASS'
                  CsrRowsInput[index]['cus_strength_result']= 'PASS'
                }
                else{
                  CsrRowsInput[index]['act_strength_result']= 'FAIL'
                  CsrRowsInput[index]['cus_strength_result']= 'FAIL'
                }
                if(parseFloat(average)>=parseFloat(cube_strength)){
                  CsrRowsInput[row_index_1]['act_result']= 'PASS'
                  CsrRowsInput[row_index_1]['cus_result']= 'PASS'
                }
                else{
                  CsrRowsInput[row_index_1]['act_result']= 'FAIL'
                  CsrRowsInput[row_index_1]['cus_result']= 'FAIL'
                }
            }
            else{
              CsrRowsInput[index]['cus_strength'] = strength;
              CsrRowsInput[row_index_1]['cus_average'] = average;
              CsrRowsInput[row_index_1]['cus_difference']= (parseFloat(average)-CsrRowsInput[row_index_1]['cus_strength']).toFixed(2);
              if(parseFloat(strength)>=parseFloat(cube_strength)){
                CsrRowsInput[index]['cus_strength_result']= 'PASS'
              }
              else{
                CsrRowsInput[index]['cus_strength_result']= 'FAIL'
              }
              if(parseFloat(average)>=parseFloat(cube_strength)){
                CsrRowsInput[row_index_1]['cus_result']= 'PASS'
              }
              else{
                CsrRowsInput[row_index_1]['cus_result']= 'FAIL'
              }
            }
            }
          })
          // console.log(total+"total");
        }
        else if(name==='act_weight'){
          CsrRowsInput[index]['cus_weight'] = value;
        }
        // console.log(JSON.stringify(CsrRowsInput)+"CsrRowsInput");
        setCsrRows(CsrRowsInput);
  }

  const generateCubeRows = () => {
    if (!inputs.casting_dt || !SelectedDcGroup.grade_number) {
      Swal.fire('Please choose casting date and delivery challan from pending list.', '', 'info');
      return;
    }

    const newCsrRows = buildCsrRowsFromAgeSetup(rowsData, inputs.casting_dt, 'edit');
    if (!newCsrRows.length) {
      Swal.fire('Please enter at least one mould count greater than 0.', '', 'info');
      return;
    }
    if (!resolveCuredPlaceFromAgeRows(rowsData)) {
      Swal.fire('Please select mould casting area for each age row.', '', 'info');
      return;
    }

    setCsrRows(newCsrRows);
    setInputs((values) => ({
      ...values,
      no_of_moulds: newCsrRows.length,
      cured_place: resolveCuredPlaceFromAgeRows(rowsData, values.cured_place),
    }));
  };

  const agePanelVisible = Boolean(inputs.casting_dt && SelectedDcGroup.grade_number);

  React.useEffect(() => {
    if (!SelectedDcGroup?.customer_name || !rowsData.length) {
      return;
    }
    setRowsData((current) => syncCubeIdsForAgeRows(current, SelectedDcGroup, inputs.casting_dt));
  }, [SelectedDcGroup?.customer_name, SelectedDcGroup?.product_name, inputs.casting_dt]);
 
  const onCancelCubeTestReport = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Do you want to cancel the Cube test report?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        cancelCubeTestReport(cookies, id)
        .then(response => {
            console.log(`cube test report with id ${id} canceled`);
            Swal.fire('Cancelled Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            console.log(error.response.data);
            displayError(error.response.data,'Cancel Failed');
        }); 
      }
      else if (result.isDismissed) {    
        Swal.fire('Not Canceled', '', 'info')  
      }
    });
  };

  const onDeleteCubeTestReport = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Are you sure to Delete?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,  
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        deleteCubeTestReport(cookies, id)
        .then(response => {
            // console.log(`CTR with id ${id} deleted`);
            Swal.fire('Deleted Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            // console.log(error.response.data);
            displayError(error.response.data,'Delete Failed');
        }); 
      } else if (result.isDismissed) {    
        Swal.fire('Not Deleted', '', 'info')  
      }
    });
  };

  const deleteTableRows = (index)=>{
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  }

  const handletableChange = (index, evnt) => {
    const { name, value } = evnt.target;
    setRowsData(applyAgeRowFieldChange(rowsData, index, name, value, SelectedDcGroup, inputs.casting_dt));
  };

  const addTableRows = () => {
    const pendingAge = inputs.pending_age_days || pendingAgeDays || 7;
    const nextAge = resolveNextAgeDays(rowsData, pendingAge);
    const defaultCubeId = buildCubeIdFromSelection(SelectedDcGroup, nextAge, inputs.casting_dt);
    const defaultCuredPlace = rowsData[0]?.cured_place || inputs.cured_place || 'plant';
    setRowsData([
      ...syncCubeIdsForAgeRows(rowsData, SelectedDcGroup, inputs.casting_dt),
      buildPendingAgeRow(nextAge, defaultCubeId, defaultCuredPlace),
    ]);
  };

  const handleSubmit=(event)=> {
    event.preventDefault();
    console.log(JSON.stringify(inputs)+"inputs submit");
    console.log(JSON.stringify(csrRows)+csrRows.length+"csrRows");
    if(inputs.no_of_moulds > 0){
      Swal.fire({title: 'Do you want to Update?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 
            console.log("can submit");
            updateCubeTestReport(cookies, {
              id:inputs.id,
              plant_id:inputs.plant_id,
              customer_id:SelectedDcGroup.customer_id,
              consignee_id:SelectedDcGroup.consignee_id,
              grade:SelectedDcGroup.product_id,
              dc_ids_list:SelectedDcGroup.dc_ids_list,
              supplied_qty:SelectedDcGroup.total_dc_qty,
              report_no:inputs.cube_test_report_no,
              report_date:getDisplayDate(inputs.csr_date),
              prefix:inputs.prefix,
              casting_dt:getDisplayDate(inputs.casting_dt),
              technician_name:inputs.technician_name?inputs.technician_name:'',
              cement_type:inputs.cement_type?inputs.cement_type:'',
              cured_place: resolveCuredPlaceFromAgeRows(rowsData, inputs.cured_place) || '',
              cement_content:inputs.cement_content?inputs.cement_content:'',
              no_of_moulds:inputs.no_of_moulds?parseInt(inputs.no_of_moulds):0,
              user_remarks:inputs.user_remarks,
              report_list:csrRows.map(q=>({
                id:parseInt(q.id),
                age:parseInt(q.age),
                age_date:getDisplayDate(q.age_date),
                sample_id:q.sample_id,
                act_weight:parseFloat(q.act_weight)?parseFloat(q.act_weight):0,
                act_load:parseFloat(q.act_load)?parseFloat(q.act_load):0,
                act_strength:parseFloat(q.act_strength)?parseFloat(q.act_strength):0,
                act_average:parseFloat(q.act_average)?parseFloat(q.act_average):0,
                act_difference:parseFloat(q.act_difference)?parseFloat(q.act_difference):0,
                act_result:(q.act_result)?(q.act_result):0,
                cus_weight:parseFloat(q.cus_weight)?parseFloat(q.cus_weight):0,
                cus_load:parseFloat(q.cus_load)?parseFloat(q.cus_load):0,
                cus_strength:parseFloat(q.cus_strength)?parseFloat(q.cus_strength):0,
                cus_average:parseFloat(q.cus_average)?parseFloat(q.cus_average):0,
                cus_difference:parseFloat(q.cus_difference)?parseFloat(q.cus_difference):0,
                cus_result:(q.cus_result),
                user_remarks:q.user_remarks,
              }))
            },id)
            .then(response => {
                Swal.fire("Updated!", "", "success");
                view();
            }).catch((error) => {
                displayError(error.response.data,"Update Failed");
            });
          } 
          else if (result.isDismissed) 
          {    
            Swal.fire('Not updated', '', 'info')  
          }
        });
    }
    else{
      Swal.fire('No of moulds must be greater than 0', '', 'info')  
    }
  }
        
  const pendingColumns = useMemo(() => getPendingColumns(true), []);

  return (
      <>
        <div id="outer-container"  className="App" > 
          <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} data-id={inputs.id}/>
          <LoadingOverlay inProgress={inProgress}/>
          <div id="page-wrap">
            <form onSubmit={handleSubmit} data-id={inputs.id}>
              <div className="container">
              <PremiumPageHeader
                module="QUALITY CONTROL"
                title="Update Compressive Strength Report"
                subtitle="Edit cube test readings and remarks. Use Print to preview the report PDF."
                modeLabel="EDIT MODE"
              />
              </div>

              <FloatingControls
                tableLink="/CubeTestReportTable"
                formLink="/CubeTestReport"
                addNewLabel="New Report"
                onCancel={Cancel}
                enableCancel={true}
                enablePrint={true}
                onPrint={handlePrint}
                enableDelete={true}
                onDelete={onDeleteCubeTestReport}
              />
              <div className="container">
                <CubeTestReportSelectionBanner selection={SelectedDcGroup} />
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                      <label htmlFor="plant_id" className="form-group col-sm-3 text-right">Plant Location</label>
                      <select id="plant_id" name="plant_id" className="form-control col-sm-7  browser-default custom-select" style={{ backgroundColor: "white", cursor: "not-allowed" }} disabled={true} value={inputs.plant_id || ""}>
                        <option value="">Select Plant</option>
                        {plants.map((item) => (
                          <option key={item.value} value={item.value}>
                                              {item.label}</option>
                        ))}
                      </select><br />

                      <label className="form-group col-sm-3 text-right">Pending Tests</label>
                      <div className="form-group col-sm-7" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <button type="button" className="btn btn-primary btn-sm" onClick={() => openPendingList(7)}>
                          7 Days Pending
                        </button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={() => openPendingList(28)}>
                          28 Days Pending
                        </button>
                      </div>
                      <br/>

                      <label htmlFor="casting_dt" className="form-group col-sm-3 text-right">Casting Date</label>
                      <input id="casting_dt" type="date" className="form-control col-sm-7  mandatory-form-control" name="casting_dt" required onChange={handleChange} value={inputs.casting_dt || ""}/><br/>

                      <div className="modal" tabIndex="-1" style={{ display: showPendingModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-xl" style={{height: "500px"}} >
                          <div className="modal-content">
                              <div className="modal-body display">
                                <div className="container item-list-table-container">
                                  <ReactTablePopUpSubmitWrapper
                                      title={pendingModalTitle || 'Pending Cube Tests'}
                                      columns={pendingColumns}
                                      data={dcGroup}
                                      onRowSubmit={handlePendingRowSelect}
                                      isLoading={isLoading}
                                      onClose={() => setShowPendingModal(false)}
                                  />
                                </div> 
                              </div>
                          </div>
                        </div>
                      </div>
                
                      <label htmlFor="cement_type" className="form-group col-sm-3 text-right">Cement Type</label>
                      <input type="text" className="form-control col-sm-7"  id="cement_type" name="cement_type"  onChange={handleChange} value={inputs.cement_type || ""}  /><br />
                    
                      <label htmlFor="cement_content" className="form-group col-sm-3 text-right">Cem Content</label>
                      <input type="text" className="form-control col-sm-7"   id="cement_content" name="cement_content"   onChange={handleChange} value={inputs.cement_content || ""} /><br/>
                      
                      <label htmlFor="technician_name" className="form-group col-sm-3 text-right">Technician Name</label>
                      <input type="text" className="form-control col-sm-7" name="technician_name" id="technician_name"  onChange={handleChange} value={inputs.technician_name || ""} /><br />
                    </div>
                  </Col>
              
                  <Col xl={6} lg={12} md={12}>
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                      <label htmlFor="csr_no" className="form-group col-sm-4 text-right">Report No</label>
                      <input type="text" className="form-control col-sm-7" id="csr_no" value={inputs.csr_no || ""} style={{cursor: "not-allowed"}} disabled={true} name="csr_no"  /><br />
                      
                      <label htmlFor="csr_date" className="form-group col-sm-4 text-right ">Date</label>
                      <input type="date" id="csr_date" name="csr_date"  className="form-control col-sm-7" value={inputs.csr_date || ""}  disabled={true} style={{cursor: "not-allowed"}}/>
                    </div>
                  </Col>
                </Row>

                <CubeTestReportAgePanel
                    visible={agePanelVisible}
                    rowsData={rowsData}
                    noOfMouldsCasted={inputs.no_of_moulds}
                    onAddRow={addTableRows}
                    onDeleteRow={deleteTableRows}
                    onChangeRow={handletableChange}
                    onGenerate={generateCubeRows}
                  />

                <div className="form-row  shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue container table-responsive">
                  <table className="table-bordered table-responsive searchTable table order-list" id="myTable" style={{textAlign:"center",borderRadius:"10px",backgroundColor:"RGB(188,232,253)"}}>
                    <thead style={{backgroundColor:"#bce8fd"}}>
                      <tr>
                        <th  style={{verticalAlign:"middle",display:"None"}}>Id</th>
                        <th  style={{verticalAlign:"middle",display:"None"}}>no_of_rows</th>
                        <th  style={{verticalAlign:"middle"}}>Sl No</th>
                        <th  style={{verticalAlign:"middle", minWidth:CUBE_ID_COLUMN_MIN_WIDTH}}>Cube ID</th>
                        <th  style={{verticalAlign:"middle"}}>Age</th>
                        <th  style={{verticalAlign:"middle"}}>Testing Date</th>
                        <th  style={{verticalAlign:"middle"}}>Weight(gms)</th>
                        <th  style={{verticalAlign:"middle"}}>Dimension(mm)</th>
                        <th  style={{verticalAlign:"middle"}}>Area mm2</th>
                        <th  style={{verticalAlign:"middle"}}>Reference Value</th>
                        <th  style={{verticalAlign:"middle"}}>Max Load(kn)</th>
                        <th  style={{verticalAlign:"middle"}}>Strength(mpa)</th>
                        <th  style={{verticalAlign:"middle"}}>Average Strength(mpa)</th>
                        <th  style={{verticalAlign:"middle",display:"None"}}>Difference</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Weight(gms)</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Max Load(kn)</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Strength(mpa)</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Average Strength2(mpa)</th>
                        <th  style={{verticalAlign:"middle",display:"None"}}>Customer Difference</th>
                        <th  style={{verticalAlign:"middle"}}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <TableRowsCubeTestReportEdit csrRows={csrRows}  handleChangeCsr={handleChangeCsr}   />
                    </tbody>
                  </table>
                </div> 

                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                  <label htmlFor="user_remarks" className="form-group col-sm-3 text-center">Remarks</label>
                  <textarea rows="2" cols="50" className="form-control col-sm-9" id="user_remarks" name="user_remarks" onChange={handleChange} value={inputs.user_remarks || ""}></textarea>
                </div>  
              </div>
                      
              <div className="footer text-center">
              <Button className="btn btn-cancel" type="button" style={{width:"100px",fontWeight:"bold"}} onClick={onCancelCubeTestReport}>Cancel Report</Button>
              </div>
            </form>
          </div>
        </div>
      </>
  );
}
export default CubeTestReportEdit;

